import { render, staticRenderFns } from "./render-generation.vue?vue&type=template&id=137d08db&"
import script from "./render-generation.vue?vue&type=script&lang=js&"
export * from "./render-generation.vue?vue&type=script&lang=js&"
import style0 from "./render-generation.vue?vue&type=style&index=0&id=137d08db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports